import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4e0cdd32")
const _hoisted_1 = { class: "text-toolbar no-printable" }
const _hoisted_2 = { class: "toolbar-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarButton = _resolveComponent("ToolbarButton")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_Range = _resolveComponent("Range")!
  const _component_ToolbarSlot = _resolveComponent("ToolbarSlot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'times'],
        display: "vertical",
        title: "Cancelar",
        onClick: _ctx.cancel
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'check'],
        display: "vertical",
        title: "Confirmar",
        onClick: _ctx.confirm
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'trash'],
        display: "vertical",
        title: "Eliminar",
        onClick: _ctx.remove
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'font'],
        selected: _ctx.showColor,
        class: "button-picker",
        display: "vertical",
        title: "Color",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showColor = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showColor)
                ? (_openBlock(), _createBlock(_component_color_picker, {
                    key: 0,
                    color: _ctx.color,
                    "show-alpha": false,
                    "sucker-hide": true,
                    class: "color-picker",
                    theme: "light",
                    onChangeColor: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateFontColor($event.hex)))
                  }, null, 8, ["color"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarSlot, {
        title: _ctx.fontSize.toString(),
        display: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Range, {
            "model-value": _ctx.fontSize,
            max: "54",
            min: "1",
            "onUpdate:modelValue": _ctx.updateFontSize
          }, null, 8, ["model-value", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}